export default __webpack_public_path__ + "static/media/logo-Growyx-new.5f87dd38.svg";